import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Spinner } from "reactstrap";

import UserDashboard from "./UserDashboard";
import CompanyDashboard2 from "./CompanyDashboard2";
import AdminDashboard from "./AdminDashboard";
import { myUser } from "../../helpers/satiBack";
import ErrorBoundary from "../../components/ErrorBoundary";

const Dashboard = () => {
  const [user, setUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    myUser()
      .then((data) => {
        setUser(data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Main Dashboard: myUser error:", err);
        setIsLoading(false);
      });
  }, []);

  const role = Number(sessionStorage.getItem("satiRol"));

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
        <span className="ml-3">Cargando...</span>
      </div>
    );
  }

  switch (role) {
    case 1:
      return (
        <ErrorBoundary>
          <AdminDashboard user={user} />
        </ErrorBoundary>
      );
    case 2:
      return (
        <ErrorBoundary>
          <CompanyDashboard2 user={user} />
        </ErrorBoundary>
      );
    case 3:
      return (
        <ErrorBoundary>
          <UserDashboard user={user} />
        </ErrorBoundary>
      );
    default:
      return <Redirect to="/login" />;
  }
};

export default Dashboard;
